<script setup lang="ts">
import { FormInput, FormSelect, FormSwitch } from "@easy/ui/forms";
import { PageSection } from "@/apps/page/page.interfaces";
import { InPageUsedTools } from "@/apps/page/page-project.interface";
import { computed } from "vue";
import { t } from "@/i18n";
import {
    TAB_EXISTING_PROJECT,
    TAB_NEW_PROJECT,
} from "@/apps/page/project/sections/useBindWithProject";

withDefaults(
    defineProps<{
        sectionId?: PageSection["id"];
        tool: InPageUsedTools;
        toolProjects: object[];
        pageNameBlur: () => void;
        projectNameError?: string;
        isAutofocused?: boolean;
    }>(),
    {
        isAutofocused: true,
    }
);
defineEmits(["tabSwitched", "actionSubmit"]);
const selectedTab = defineModel("selectedTab");
const shouldHaveExistingOption = defineModel("shouldHaveExistingOption");
const chosenProjectId = defineModel("chosenProjectId");
const projectName = defineModel("projectName");

const tabs = computed(() => {
    const tabList = [];
    if (shouldHaveExistingOption.value) {
        tabList.push({
            label: t("page.bind_section_modal.project_existing"),
            value: TAB_EXISTING_PROJECT,
        });
    }
    tabList.push({
        label: t("page.bind_section_modal.project_new"),
        value: TAB_NEW_PROJECT,
    });
    return tabList;
});
</script>

<template>
    <div>
        <FormSwitch
            v-if="tabs.length > 1"
            class="my-4"
            v-model="selectedTab"
            :options="tabs"
            @update:modelValue="$emit('tabSwitched', $event)"
        />
        <template v-if="selectedTab === TAB_NEW_PROJECT">
            <FormInput
                :autofocus="isAutofocused"
                required
                v-model="projectName"
                @keyup.enter="$emit('actionSubmit')"
                :title="$t('page.sections.new_project_name')"
                @blur="pageNameBlur"
                :error="projectNameError"
            />
        </template>
        <template v-else-if="selectedTab === TAB_EXISTING_PROJECT">
            <FormSelect
                :label="$t('page.bind_section_modal.choose_project')"
                :options="toolProjects"
                :value="chosenProjectId"
                :placeholder="$t('shared.search')"
                v-model="chosenProjectId"
            />
        </template>
    </div>
</template>
